export const LayoutTypes = {
  Base: 'base'
};
